

export enum FulltruckEnum {
  YES = "YES",
  NO = "NO"
}